import React, { FC, useEffect } from 'react';
import { Box, Alert, AlertTitle, Button, Card, CardActions, CardContent, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

type LocationState = {
    state: {
        batchId: string;
    };
};

const DoneInvoice: FC = () => {
    const { t: translate } = useTranslation(['invoices']);
    const navigate = useNavigate();
    const location = useLocation();
    const batchId = (location as LocationState).state?.batchId;

    useEffect(() => {
        if (!batchId) {
            navigate('/invoices/invoices');
        }
    }, [batchId]);

    return (
        <Container maxWidth="sm">
            <Card>
                <CardContent>
                    <Box mb={2}>
                        <Alert severity="info">
                            <AlertTitle>{translate('invoices:BATCH_RUNNING_TITLE')}</AlertTitle>
                            {translate('invoices:BATCH_RUNNING_BODY')}
                        </Alert>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                        {translate('invoices:BATCH_RUNNING_DETAIL')}
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
                    <Button variant="outlined" onClick={() => navigate('/invoices/invoices')}>
                        {translate('invoices:BACK_TO_INVOICE_LIST')}
                    </Button>
                    <Button variant="contained" onClick={() => navigate(`/invoices/invoice-batches/${batchId}`)}>
                        {translate('invoices:VIEW_BATCH_STATUS')}
                    </Button>
                </CardActions>
            </Card>
        </Container>
    );
};

export default DoneInvoice;
